import React, { useEffect } from 'react';
import './TermsModal.css';

const TermsModal = ({ isOpen, onClose }) => {
  // Disable body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="terms-backdrop" onClick={onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-header">
          <div className="terms-title-group">
            <i className="fa-solid fa-file-shield terms-icon"></i>
            <h3>Términos y Condiciones</h3>
          </div>
          <button className="terms-close-btn" onClick={onClose} aria-label="Cerrar modal">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="terms-body">
          <h2>TÉRMINOS Y CONDICIONES DE USO DEL PORTAL DE CLIENTES</h2>
          
          <div className="terms-section">
            <h4>1. INTRODUCCIÓN Y ACEPTACIÓN</h4>
            <p>
              <strong>BIENVENIDO A CASH SOL.</strong> Al crear una cuenta, registrarse y/o utilizar nuestro portal web (en adelante, el "Portal"), usted (en adelante, el "Usuario" o "Cliente") acepta expresamente y de manera incondicional todos los términos y condiciones aquí detallados. Si no está de acuerdo con estos términos, deberá abstenerse de utilizar el Portal.
            </p>
          </div>

          <div className="terms-section">
            <h4>2. ELEGIBILIDAD DEL USUARIO</h4>
            <p>
              El Portal está dirigido exclusivamente a personas naturales mayores de 20 años, con plena capacidad legal para contratar, residentes en el Perú y que cuenten con un documento de identidad válido (DNI).
            </p>
          </div>

          <div className="terms-section">
            <h4>3. VERACIDAD DE LA INFORMACIÓN</h4>
            <p>
              El Usuario declara bajo juramento que toda la información registrada en el formulario de registro (nombres, apellidos, correo, teléfono, DNI y situación financiera) es exacta, actual y verdadera. Cash Sol se reserva el derecho de suspender o cancelar la cuenta si se detecta información falsa o fraudulenta.
            </p>
          </div>

          <div className="terms-section">
            <h4>4. CONDICIONES Y EVALUACIÓN DEL CRÉDITO</h4>
            <ul>
              <li>
                <strong>Solicitud:</strong> El registro en el Portal y la simulación de cuotas no constituyen una aprobación automática del préstamo. Toda solicitud está sujeta a una evaluación crediticia.
              </li>
              <li>
                <strong>Tasas y Cronograma:</strong> Las condiciones definitivas del crédito (TEM, TCEM, comisiones, y el cronograma definitivo de pagos) se fijarán en el Contrato de Préstamo y la Hoja Resumen que el cliente firmará. El cronograma visualizado en el crédito aprobado refleja las cuotas ordinarias del préstamo.
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h4>5. CONDICIONES DE PAGO Y ATRASOS</h4>
            <ul>
              <li>
                <strong>Pago Oportuno:</strong> El Cliente se compromete a pagar la CUOTA indicada en su cronograma en o antes de la FECHA DE PAGO establecida.
              </li>
              <li>
                <strong>Efectos del Atraso:</strong> El incumplimiento del pago en la fecha de vencimiento generará automáticamente la aplicación de intereses moratorios y/o penalidades por atraso, de acuerdo con las tasas permitidas por la legislación peruana y detalladas en su contrato. Asimismo, el atraso facultará a Cash Sol a reportar el estado de morosidad a las Centrales de Riesgo (Infocorp/Equifax, entre otras).
              </li>
            </ul>
          </div>

          <div className="terms-section">
            <h4>6. SEGURIDAD DE LA CUENTA</h4>
            <p>
              El acceso al Portal se realiza mediante una contraseña personal e intransferible creada por el Usuario en la pantalla de registro. El Usuario es el único responsable de mantener la confidencialidad de su contraseña y de todas las operaciones realizadas en su cuenta.
            </p>
          </div>

          <div className="terms-section">
            <h4>7. PROPIEDAD INTELECTUAL</h4>
            <p>
              Todos los contenidos, marcas (Presta Cash Sol), logotipos, diseños, código fuente y desarrollos tecnológicos en este Portal están protegidos por las leyes de propiedad intelectual en el Perú y son propiedad exclusiva de la empresa.
            </p>
          </div>

          <div className="terms-section">
            <h4>8. LEY APLICABLE Y JURISDICCIÓN</h4>
            <p>
              Estos Términos y Condiciones se rigen por las leyes de la República del Perú. Cualquier controversia derivada de este documento será resuelta ante los jueces y tribunales de la ciudad de Lima, renunciando el Usuario a cualquier otro fuero.
            </p>
          </div>
        </div>

        <div className="terms-footer">
          <button className="btn-primary terms-accept-btn" onClick={onClose}>
            Entendido
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
